import { memo, useMemo } from 'react'

import { useAppSelector } from 'hooks'
import {
  getMultiAnswerRawAnswers,
  getRawAnswer,
  getRawAnswerList,
  getRawAnswerListFromEdit,
} from 'Helpers/SettingsHelper'
import { Question } from 'Slices/Settings/SettingsSlice'
import DynamicAnswerByType from './DynamicAnswerByType'
import { SettingsName, SettingsAnswerEmptyValue } from 'Constants/Settings'

interface AnswerCellProps {
  respondingEntityId: string
  question: Question
  userCanEdit: boolean
  settingsName?: string
}

function AnswerCell(props: AnswerCellProps) {
  const answers = useAppSelector(state => state.present.settings.answers)
  const editedAnswers = useAppSelector(state => state.present.settings.editedAnswers)

  const rawValue = useMemo(() => {
    if (props.question.isMultiAnswers) {
      return getMultiAnswerRawAnswers(
        props.respondingEntityId,
        props.question.code,
        getRawAnswerList(props.question.settingsName, answers),
      )
    }

    return getRawAnswer(
      props.respondingEntityId,
      props.question.code,
      getRawAnswerList(props.question.settingsName, answers),
    )?.answer
  }, [props.question, props.respondingEntityId, answers])

  const editValue = useMemo(() => {
    if (props.question.isMultiAnswers) {
      return getMultiAnswerRawAnswers(
        props.respondingEntityId,
        props.question.code,
        getRawAnswerListFromEdit(props.question.settingsName, editedAnswers),
      )
    }

    return getRawAnswer(
      props.respondingEntityId,
      props.question.code,
      getRawAnswerListFromEdit(props.question.settingsName, editedAnswers),
    )?.answer
  }, [editedAnswers, props.question, props.respondingEntityId])

  const storedValue = useMemo(() => {
    if (props.question.isMultiAnswers) {
      return editValue.length > 0 ? (editValue[0] === SettingsAnswerEmptyValue ? [] : editValue) : rawValue
    }
    return editValue ? editValue : rawValue
  }, [editValue, props.question.isMultiAnswers, rawValue])

  return props.settingsName !== SettingsName.Application ? (
    <div className='big-table-cell'>
      <DynamicAnswerByType
        question={props.question}
        storedValue={storedValue}
        respondingEntityId={props.respondingEntityId}
        userCanEdit={props.userCanEdit}
      />
    </div>
  ) : null
}

export default memo(AnswerCell)
